import { render, staticRenderFns } from "./VideosTable.vue?vue&type=template&id=210f5022"
import script from "./VideosTable.vue?vue&type=script&lang=js"
export * from "./VideosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports